import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { StyledGBDFLButton } from '../ServiceRequestStyles';
import { changeFormValue } from '../../../passport/Passport';
import { ServiceRequestApi } from '../ServiceRequestApi';
import Notice from '../../../modules/utils/Notice';
import PassportForm from '../../../passport/FormData/PassportForm';
import { saveBinFunder } from '../ServiceRequestDucks';
import { useDispatch } from 'react-redux';

const requestGBDFL = async ({ setLoading, code, value, t, dispatch }) => {
  try {
    let queue_type =
      PassportForm.values['request_form_voucher_acceptance_ddo_short.queued_type'];
    setLoading(true);
    const metadataKey = code.split('.')[0];
    const data = await ServiceRequestApi.searchVoucherQueue(value, queue_type);
    const info = data.data.result;
    if (data.status === 200) {
      const surname = _.get(info, 'childSurname');
      const name = _.get(info, 'childName');
      const middlename = _.get(info, 'childMiddlename');
      const birthday = _.get(info, 'childBirthday');
      const ageGroup = _.get(info, 'ageGroup');
      const userCategory = _.get(info, 'userCategory');
      const language = _.get(info, 'bulletinLanguage');
      const nameGroupKk = _.get(info, `nameGroupKk`);
      const nameGroupRu = _.get(info, `nameGroupRu`);
      const queuedRegion = _.get(info, `queuedRegion`);
      const kindergartenVoucherQueueId = _.get(info, `id`);
      const serviceProviderRuName = _.get(info, `serviceProviderRuName`);
      const serviceProviderKkName = _.get(info, `serviceProviderKkName`);

      dispatch(saveBinFunder(info.serviceProviderBin));
      switch (code) {
        case 'request_form_voucher_acceptance_ddo_short.child_iin':
          changeFormValue(`${metadataKey}.child_surname`, surname);
          changeFormValue(`${metadataKey}.child_middlename`, middlename);
          changeFormValue(`${metadataKey}.child_name`, name);
          changeFormValue(`${metadataKey}.child_birthday`, birthday);
          changeFormValue(`${metadataKey}.user_category`, userCategory);
          changeFormValue(`${metadataKey}.voucher_region`, queuedRegion);
          changeFormValue(`${metadataKey}.voucher_num`, kindergartenVoucherQueueId);
          changeFormValue(`${metadataKey}.kindergarden_name`, serviceProviderRuName);
          changeFormValue(`${metadataKey}.kindergarden_name_kz`, serviceProviderKkName);
          changeFormValue(`${metadataKey}.kindergarden_group`, ageGroup);
          changeFormValue(`${metadataKey}.lang_study`, language);
          changeFormValue(`${metadataKey}.name_group_kk`, nameGroupKk);
          changeFormValue(`${metadataKey}.name_group_ru`, nameGroupRu);
          break;
        default:
          break;
      }
    }
  } catch (error) {
    const errorCode = _.get(error, 'response.data.errors[0].code');
    if (errorCode === 'error.kq_with_active_direction_not_found') {
      Notice.error(t('gbdflButton_iinNotFound_in_voucher_3'));
    } else if (errorCode === 'error.kq_requester_iin_doesnt_match') {
      Notice.error(t('gbdflButton_iinNotFound_4'));
    } else {
      Notice.error(t('gbdflButton_iinNotFound_in_voucher_3'));
    }
  } finally {
    setLoading(false);
  }
};

function VoucherAcceptanceDDOButton({ code, value }) {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  return (
    <div>
      <StyledGBDFLButton
        color="secondary"
        loading={loading}
        text={t('gbdflButton_search')}
        disabled={value.length !== 12}
        onClick={() =>
          requestGBDFL({ setLoading, code, value, t, lang: i18n.language, dispatch })
        }
      />
    </div>
  );
}

export default VoucherAcceptanceDDOButton;
